export default function prepareFilterParams(companyId, filters, rowsPerPage, page) {
  const result = { 'companyId.equals': companyId, size: rowsPerPage, page };

  if (filters.statuses?.length) result['status.in'] = filters.statuses.map((item) => item.value);

  if (filters?.taskName) result['taskName.contains'] = filters.taskName.trim();

  return result;
}
